import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserPill = _resolveComponent("UserPill")!
  const _component_PeoplePicker = _resolveComponent("PeoplePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.mode === 'view')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownUsers, (user) => {
            return (_openBlock(), _createBlock(_component_UserPill, {
              user: user,
              key: user.id
            }, null, 8, ["user"]))
          }), 128))
        ]))
      : (_ctx.mode === 'edit')
        ? (_openBlock(), _createBlock(_component_PeoplePicker, {
            key: 1,
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            options: _ctx.allUsers
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true)
  ]))
}